export default "__VITE_ASSET__1cf49b59__"